import graphQLAdapter from "@/adapters/graphQL.adapter.js";
// import FavoriteVariantCharacters from "@/entities/favoriteVariantCharacters.entity.js";

/**
 * FavoriteVariantCharacters Service Class
 *
 * @export
 * @class
 */
export default class {
  constructor () {
    // eslint-disable-next-line
    this.adapter = new graphQLAdapter();
    this.getFavoriteVariantCharacters = getFavoriteVariantCharacters.bind(this);
    this.updateVariantCharacterFavorite = updateVariantCharacterFavorite.bind(this);
    this.deleteVariantCharacterFavorite = deleteVariantCharacterFavorite.bind(this);
  }

  async get (options) {
    await this.adapter.init();
    const res = await this.getFavoriteVariantCharacters(options);

    return !res.data.favoriteVariantCharacters
      ? []
      : res.data.favoriteVariantCharacters;
  }

  async update (options) {
    await this.adapter.init();
    const res = await this.updateVariantCharacterFavorite(options);

    return !res.data.variantCharacterFavorite
      ? {}
      : res.data.variantCharacterFavorite;
  }

  async delete (options) {
    await this.adapter.init();
    const res = await this.deleteVariantCharacterFavorite(options);

    return !res.data.variantCharacterFavoriteDelete
      ? {}
      : res.data.variantCharacterFavoriteDelete;
  }
}

function getFavoriteVariantCharacters (options = {}) {
  const query = `
    query ($clientGroupId: ID!) {
      favoriteVariantCharacters(clientGroupId: $clientGroupId) {
        id
        variantCharacter {
          id
          imageUrl
          imageUrlForTablet
          managementCode1
          managementCode2
          inputCode
        }
        variantCharacterGroup {
          id
          font
          code
          searchConditions
        }
        variantCharacterId
        character
        font
      }
    }
  `;
  return this.adapter.query(query, options);
}

function updateVariantCharacterFavorite (options = {}) {
  const mutation = `
    mutation (
      $variantFavoriteCharacter: VariantFavoriteCharacterInput!
    ) {
      variantCharacterFavorite(
        variantFavoriteCharacter: $variantFavoriteCharacter
      ) {
        id
        variantCharacterId
        character
        font
      }
    }
  `;

  return this.adapter.mutation(mutation, options);
}

function deleteVariantCharacterFavorite (options = {}) {
  const mutation = `
    mutation (
      $variantFavoriteCharacterId: ID!
    ) {
      variantCharacterFavoriteDelete(
        variantFavoriteCharacterId: $variantFavoriteCharacterId
      ) {
        id
        variantCharacterId
        character
        font
      }
    }
  `;

  return this.adapter.mutation(mutation, options);
}
